import { Button } from "@/components/ui/button";
import { PageHeader, StatStrip } from "@/components/ui/page-header";
import { Icon } from "@/lib/icons";
import { cn } from "@/lib/utils";

interface ThemeImportsHeaderProps {
  title: string;
  description: string;
  totalCount: number;
  activeCount: number;
  inactiveCount: number;
  totalLabel: string;
  activeLabel: string;
  inactiveLabel: string;
  importLabel: string;
  refreshLabel: string;
  isLoading: boolean;
  onImport: () => void;
  onRefresh: () => void;
}

export function ThemeImportsHeader({
  title,
  description,
  totalCount,
  activeCount,
  inactiveCount,
  totalLabel,
  activeLabel,
  inactiveLabel,
  importLabel,
  refreshLabel,
  isLoading,
  onImport,
  onRefresh,
}: ThemeImportsHeaderProps) {
  return (
    <PageHeader
      level="section"
      title={title}
      description={description}
      actions={
        <>
          <Button variant="outline" size="sm" disabled={isLoading} onClick={onRefresh}>
            <Icon name="refreshCw" className={cn(isLoading && "animate-spin")} />
            {refreshLabel}
          </Button>
          <Button size="sm" onClick={onImport}>
            <Icon name="upload" />
            {importLabel}
          </Button>
        </>
      }
    >
      <StatStrip
        items={[
          { label: totalLabel, value: `${totalCount}` },
          { label: activeLabel, value: `${activeCount}` },
          { label: inactiveLabel, value: `${inactiveCount}` },
        ]}
      />
    </PageHeader>
  );
}
